import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const SchKeywordListDesktop = styled.div`
  width: 541px;
  background-color: #fff;
  border: 1px solid #eee;
  box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.03);
  ${mixin.flex({ wrap: 'wrap', justify: 'flex-start' })}

  .title {
    font-size: 15px;
    line-height: 130%;
    margin-bottom: 18px;
  }

  .recent {
    width: 59.14972273567%;
    height: 383px;
    padding: 24px;

    .item {
      background-color: #fff;
      height: auto;
      max-width: none;
      padding: 0;
      width: 100%;
      height: 19px;
      margin-top: 12px;

      &:first-child {
        margin-top: 0;
      }

      .btn {
        .text {
          font-size: 15px;
          color: #555;
          max-width: 242px;
        }

        width: 100%;
        ${mixin.flex({ justify: 'flex-start' })}
      }

      .btn-close {
        width: 19px;
        height: 19px;
        ${mixin.flex({ justify: 'flex-end' })}
      }
    }

    .is-empty {
      font-size: 15px;
      line-height: 130%;
      color: #999;
    }
  }

  .popular {
    width: 40.48059149723%;
    height: 383px;
    padding: 24px;
    border-left: 1px solid #f5f5f5;

    ol {
      margin: 0;
      max-height: none;
    }

    .item {
      padding: 0 !important;
      width: 100%;
      height: 19px;
      margin-top: 12px;

      &:first-child {
        margin-top: 0;
      }

      .btn {
        height: auto;
      }

      .word {
        font-size: 15px;
        color: #555;
        font-weight: 400;
      }

      .num {
        min-width: 20px;
        font-size: 14px;
        color: #999;
        font-weight: 400;
        margin-right: 0;
      }

      .new {
        font-size: 11px;
        margin-left: 4px;
      }
    }
  }

  .bottom {
    width: 100%;
    border-top: 1px solid #eee;
    text-align: right;
    padding-right: 20px;

    .btn {
      height: 40px;
      font-size: 13px;
      line-height: 130%;
      color: #999;
    }
  }
`;
